import { useLocation } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { prop } from 'ramda';

import { useDeviceSelector, useAppSelector } from 'js/store/hooks';
import { useIsSupportedBrowser } from 'js/app/hooks/device/hooks/useIsSupportedBrowser';

import { TAG_KEY, BROWSERS_LIST } from '../constants';

export const useOldBrowser = () => {
    const [popupData, setPopupData] = useState({ articleId: '', button: {} });
    const [supportedBrowsersVersions, setSupportedBrowsersVersions] = useState({});

    const tags = useAppSelector(prop('tags'));
    const { pathname } = useLocation();
    const deviceBrowserName = useDeviceSelector(prop('browserName'));
    const isSupportedBrowser = useIsSupportedBrowser();
    const { oldBrowserMessageConfig, excludeFromPages } = useMemo(() => {
        const tag = tags?.find(({ tagTypeId }) => tagTypeId === TAG_KEY);

        if (!tag) {
            return {};
        }

        return {
            oldBrowserMessageConfig: tag.config,
            excludeFromPages: tag.config.excludeFromPages?.map(({ pageURL }) => pageURL) || []
        };
    }, [tags]);

    useEffect(() => {
        if (oldBrowserMessageConfig) {
            setSupportedBrowsersVersions(
                BROWSERS_LIST.reduce((acc, browserName) => {
                    acc[browserName] = oldBrowserMessageConfig[browserName] ? oldBrowserMessageConfig[`${browserName}Version`] + 1 : 0;

                    return acc;
                }, { androidNative: oldBrowserMessageConfig.androidNative })
            );
        }
    }, [oldBrowserMessageConfig]);

    useEffect(() => {
        if (
            !isSupportedBrowser(supportedBrowsersVersions) &&
            !excludeFromPages.includes(pathname)
        ) {
            setPopupData({
                articleId: oldBrowserMessageConfig[`${deviceBrowserName}WC`],
                button: {
                    title: oldBrowserMessageConfig[`${deviceBrowserName}CTA`],
                    action: oldBrowserMessageConfig[`${deviceBrowserName}URL`]
                }
            });
        }
    }, [supportedBrowsersVersions, deviceBrowserName, oldBrowserMessageConfig, excludeFromPages, pathname, isSupportedBrowser]);

    return popupData;
};
